var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9272 24.8222C24.9033 24.2015 25.1268 23.5968 25.5486 23.1408C25.9703 22.6849 26.5557 22.4149 27.1764 22.3903L45.9446 21.6581C46.5652 21.6343 47.17 21.8578 47.6259 22.2795C48.0819 22.7013 48.3518 23.2867 48.3764 23.9073L49.1086 42.6756C49.1113 43.2831 48.878 43.868 48.4578 44.3069C48.0376 44.7457 47.4634 45.0042 46.8563 45.0279C46.2492 45.0516 45.6566 44.8386 45.2035 44.4338C44.7505 44.029 44.4722 43.4641 44.4276 42.8582L43.9159 29.7425L28.1291 46.8111C27.707 47.2675 27.1209 47.5375 26.4998 47.5617C25.8787 47.5859 25.2734 47.3624 24.817 46.9403C24.3607 46.5183 24.0907 45.9322 24.0665 45.3111C24.0422 44.69 24.2657 44.0846 24.6878 43.6283L40.4747 26.5597L27.359 27.0714C26.7383 27.0952 26.1336 26.8717 25.6776 26.45C25.2217 26.0282 24.9518 25.4428 24.9272 24.8222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.9ffdea7574aa8b49f371f31ac698141b.svg";
export { ForwardRef as ReactComponent };